import { changeIntegrationLegalHold } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const LegalHold: React.FC = () => {
  const dispatch = useDispatch();

  const { legal_hold: legalHold } = useSelector(getIntegrationSettingsForm);

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(changeIntegrationLegalHold(e.target.value === 'true'));
  };

  return (
    <div className="flex flex-col gap-2">
      <div>
        <span>Is there a legal hold?</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div>
        <div className="flex flex-col gap-2">
          <label htmlFor="legal-hold-yes" className="flex justify-start items-center w-22">
            <input
              type="radio"
              id="legal-hold-yes"
              name="legal-hold"
              value="true"
              onChange={handleTypeChange}
              checked={legalHold === true}
              className="input-radio"
            />
            <span className="text ml-1">Yes</span>
          </label>
          <label htmlFor="legal-hold-no" className="flex justify-start items-center w-22">
            <input
              type="radio"
              id="legal-hold-no"
              name="legal-hold"
              value="false"
              onChange={handleTypeChange}
              checked={legalHold === false}
              className="input-radio"
            />
            <span className="text ml-1">No</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default LegalHold;
